<template>
  <span id="toolbarContainer">
    <!-- <v-toolbar
      id="toolbar"
      color="secondary"
      dense
      flat
      v-if="menu.toolbar"
      :key="menu.reloadableKey"
    >
      <span v-if="!rotaroot" :style="{ position: 'absolute' }">
        <v-icon color="black" small left @click="voltar()">fas fa-arrow-left</v-icon>
      </span>
      <v-spacer></v-spacer>
      <v-toolbar-title class="text-truncate">
        <span class="subtitle-1">{{ rotaatual() }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>-->
  </span>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  watch: {
    $route() {
      this.checkToolbar();
    }
  },
  mounted() {
    this.checkToolbar();
  },
  computed: {
    ...mapState(["menu", "badges", "app"]),

    rotaroot() {
      return !!this.$route.meta.root;
    }
  },
  methods: {
    ...mapMutations([
      "toggleMenul",
      "toggleMenur",
      "updateMainSearch",
      "updateMenuState"
    ]),
    rotaatual() {
      // console.log(this.$route)
      return this.$route.meta.title
        ? this.$route.meta.title
        : this.$route.params.title
        ? this.$route.params.title
        : "";
    },
    title: function() {
      return this.user.nome;
    },
    voltar() {
      this.$router.go(-1);
    },
    checkToolbar() {
      // debugger
      const toolbar = !this.rotaroot || !!this.$route.meta.forcetoolbar;
      this.updateMenuState({ toolbar: toolbar });

      try {
        const toolbarBehavior = !!this.$route.meta.toolbarBehavior;
        this.updateMenuState({
          toolbarBehavior: toolbarBehavior
        });
        //eslint-disable-next-line
      } catch (err) {}
    }
  }
};
</script>

<style>
#toolbarContainer .v-input .v-icon {
  font-size: 16px !important;
}
.noborder.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.noborder.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
#toolbarContainer .v-input__slot {
  border: thin solid color-mix(in srgb, var(--v-border-base), transparent 40%);
  border-radius: 5px;
  background-color: var(--v-muted-base);
}
</style>
